module.exports = __webpack_public_path__ + "img/Quarter_Icon.5a118f4f.png";